import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import MapSection from './components/MapSection';
import ContactInfo from './components/ContactInfo';
import ContactForm from './components/ContactForm';
import usePageMeta from '@/hooks/usePageMeta';

const KontaktPage = () => {
  usePageMeta({
    title: 'Kontakt – gowiTEC Reichshof-Wehnrath | Automatisierungstechnik anfragen',
    description: 'Kontaktieren Sie gowiTEC in Reichshof-Wehnrath: Telefon, E-Mail oder Kontaktformular. Persönliche Beratung zu Sondermaschinenbau, SPS und Automatisierung.',
    keywords: 'Kontakt gowiTEC, Automatisierung anfragen, Maschinenbau Beratung, Reichshof Kontakt',
    canonical: 'https://gowitec.de/kontakt',
  });

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Navbar />

      {/* Page Header */}
      <section className="relative pt-32 pb-16 md:pt-40 md:pb-20 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=modern%20industrial%20factory%20interior%20with%20machinery%20and%20automation%20equipment%2C%20clean%20professional%20environment%2C%20steel%20and%20concrete%20architecture%2C%20soft%20blue%20tones%2C%20wide%20angle%20shot&width=1440&height=400&seq=kontakt-hero-01&orientation=landscape"
            alt="gowiTEC Kontakt – Industrieautomation Reichshof"
            className="w-full h-full object-cover object-top"
            loading="eager"
            fetchPriority="high"
            decoding="async"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0f1f4a]/80 via-[#0f1f4a]/70 to-[#0f1f4a]/80"></div>
        </div>
        <div className="relative max-w-7xl mx-auto px-6 md:px-10 text-center w-full">
          <p className="text-[#DC2626] text-sm font-semibold uppercase tracking-widest mb-3">Kontakt</p>
          <h1 className="text-2xl sm:text-3xl md:text-5xl font-bold text-white mb-4 leading-tight">
            Sprechen Sie uns an
          </h1>
          <p className="text-white/70 text-sm md:text-lg max-w-2xl mx-auto leading-relaxed">
            Wir sind persönlich für Sie da – ob Projektanfrage, technische Frage oder einfach ein erstes Gespräch.
          </p>
        </div>
      </section>

      {/* Main Content */}
      <main className="flex-1 py-16 md:py-20">
        <div className="max-w-7xl mx-auto px-6 md:px-10">

          {/* Top: Info + Form */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
            <ContactInfo />
            <ContactForm />
          </div>

          {/* Map + Anfahrt */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <span className="w-8 h-8 flex items-center justify-center bg-[#1E3A8A]/10 rounded-lg">
                <i className="ri-map-2-line text-[#1E3A8A] text-lg"></i>
              </span>
              <h2 className="text-xl font-bold text-gray-900">So finden Sie uns</h2>
            </div>
            <MapSection />
          </div>

        </div>
      </main>

      <Footer />
    </div>
  );
};

export default KontaktPage;
